import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'dateTimeFormat',
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(value: string, format: 'time' | 'date' = 'time'): string | null {
    if (!value) return null;
    const dateTime = DateTime.fromISO(value, { zone: 'utc' });
    if (format === 'time') {
      return dateTime.toFormat('hh:mm a');
    } else if (format === 'date') {
      return dateTime.toFormat('MM/dd/yyyy');
    }

    return null;
  }
}
